module.exports = __webpack_public_path__ + "jsj_h5_static/img/yghm.b9a8c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/yghm.png
// module id = YfHQ
// module chunks = 36